import { FormGroup, ModalWrapper, TextInput } from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { sendTeamCreatedEmail } from "../../actions/email";
import { addTeamNameToNotification, updateNewTeamNotificationStatus } from "../../actions/notifications"; // prettier-ignore
import { addTeams, fetchTeams } from "../../actions/teams";
import { useValidation, validateNotEmpty, validateTeamName } from "../../utils/validation"; // prettier-ignore

const defaultState = {
  first_name: "",
  last_name: "",
  cell_phone: "",
  email: "",
  team_name: "",
};

const validators = {
  first_name: [validateNotEmpty],
  last_name: [validateNotEmpty],
  cell_phone: [validateNotEmpty],
  email: [validateNotEmpty],
  team_name: [validateNotEmpty, validateTeamName],
};

const NewTeamForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form, setForm] = useState(defaultState);
  const [validation, invalid] = useValidation(form, validators);

  const handleFormSubmit = () => {
    const team = {
      ...form,
      id: new Date().getTime().toString(36),
      event: "5458",
    };
    dispatch(addTeams(team));
    dispatch(sendTeamCreatedEmail({ email: team.email, teamName: team.team_name })); // prettier-ignore
    dispatch(addTeamNameToNotification(team.team_name));
    dispatch(updateNewTeamNotificationStatus("open"));
    navigate("/");
    return true;
  };

  useEffect(() => {
    dispatch(fetchTeams());
  }, [dispatch]);

  return (
    <div className="new-team-page form-page">
      <h4>Create A Team</h4>
      <FormGroup invalid={false} legendText="" message={false}>
        <TextInput
          id="firstname-newteam"
          invalid={Boolean(validation.first_name) && form.team_name !== ""}
          invalidText={validation.first_name}
          labelText="My first name is:"
          light={true}
          type="text"
          value={form.first_name}
          onChange={(e) => setForm({ ...form, first_name: e.target.value })}
        />
        <TextInput
          id="lastname-newteam"
          invalid={Boolean(validation.last_name) && form.team_name !== ""}
          invalidText={validation.last_name}
          labelText="My last name is:"
          light={true}
          type="text"
          value={form.last_name}
          onChange={(e) => setForm({ ...form, last_name: e.target.value })}
        />
        <TextInput
          id="cellphonenumber-newteam"
          invalid={Boolean(validation.cell_phone) && form.team_name !== ""}
          invalidText={validation.cell_phone}
          labelText="My cell is:"
          light={true}
          type="text"
          value={form.cell_phone}
          onChange={(e) => setForm({ ...form, cell_phone: e.target.value })}
        />
        <TextInput
          id="email-newteam"
          invalid={Boolean(validation.email) && form.team_name !== ""}
          invalidText={validation.email}
          labelText="My email is:"
          light={true}
          type="email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
        <TextInput
          id="teamname-newteam"
          invalid={Boolean(validation.team_name) && form.team_name !== ""}
          invalidText={validation.team_name}
          labelText="The Team Name I am creating is:"
          light={true}
          type="text"
          value={form.team_name}
          onChange={(e) => setForm({ ...form, team_name: e.target.value })}
        />
      </FormGroup>
      <ModalWrapper
        aria-label="Confirm Team Modal"
        buttonTriggerText="Create Team"
        disabled={invalid}
        handleSubmit={handleFormSubmit}
        hasScrollingContent={false}
        id="confirm-team-modal"
        modalHeading="Confirm Team"
        primaryButtonText="Submit"
        renderTriggerButtonIcon={undefined}
        secondaryButtonText="Back"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        shouldCloseAfterSubmit={true}
        triggerButtonKind="primary"
      >
        <div style={{ padding: "1rem", textAlign: "left" }}>
          <p>First Name: {form.first_name}</p>
          <p>Last Name: {form.last_name}</p>
          <p>Cell Phone: {form.cell_phone}</p>
          <p>Email: {form.email}</p>
          <p>Team Name: {form.team_name}</p>
        </div>
      </ModalWrapper>
    </div>
  );
};

export default NewTeamForm;
